import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
import { PageHero } from '../components/layout/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Reveal } from '../components/ui/Reveal';
import { CtaBand } from '../components/ui/CtaBand';
import { manifestoFormats } from '../data/media';
import { policies } from '../data/policies';
export function Manifesto() {
  return <>
      <PageHero eyebrow="Manifesto centre" title="Read it in two minutes, or in ninety-six pages." intro="The same commitments, published in whichever format fits the time, bandwidth and language you have." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Manifesto'
    }]} data-id="element-1047" data-mp="31uf6nhracvpm" />

      <section className="bg-sand-50 py-16 lg:py-24" aria-labelledby="formats-heading" data-id="element-1048" data-mp="2j24fgl5zum7c">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1049" data-mp="2j3xdxd6ge049">
          <SectionHeading eyebrow="Choose a format" title="Six ways in" data-id="element-1050" data-mp="2e3je2if09whb" />
          <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-1051" data-mp="zvkjlv9078ha">
            {manifestoFormats.map((format, index) => <li key={format.title} data-id="element-1052" data-mp="14on65jfd5hnz" data-mpi={index}>
                <Reveal delay={Math.min(index, 5) * 0.03} className="h-full" data-id="element-1053" data-mp="qw7a52kvqjwk">
                  <article className="flex h-full flex-col rounded-card border border-sand-200 bg-white p-6" data-id="element-1054" data-mp="qu49zpq0jae4">
                    <h3 className="font-display text-[21px] leading-snug text-ink" data-id="element-1055" data-mp="1in3k9vfk2ag5">
                      {format.title}
                    </h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-1056" data-mp="1nkwtyyg2hml6">
                      {format.description}
                    </p>
                    <p className="mt-4 text-[13px] text-slate-500" data-id="element-1057" data-mp="1eli5g4jgnm3b">{format.meta}</p>
                    <button type="button" className="mt-auto inline-flex items-center gap-2 pt-6 text-[14px] font-semibold text-green-700 transition-colors duration-150 ease-emphasis hover:text-green-800" data-id="element-1058" data-mp="1encofdb6944r">
                      <DownloadIcon aria-hidden className="h-4 w-4" data-id="element-1059" data-mp="24v0qrzdk2qx9" />
                      {format.action}
                    </button>
                  </article>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-24" aria-labelledby="topics-heading" data-id="element-1060" data-mp="1r4ne5jppyo1l">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1061" data-mp="1m4refwo21iru">
          <SectionHeading eyebrow="Explore by topic" title="Jump straight to what affects you" intro="Each topic links to the full policy, including targets and funding logic." data-id="element-1062" data-mp="1m2y6me1pgsi9" />
          <ul className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1063" data-mp="185jbcsortqid">
            {policies.map(policy => <li key={policy.slug} data-id="element-1064" data-mp="36l5rdb3w1dyg">
                <Link to={`/agenda/${policy.slug}`} className="group flex items-center justify-between rounded-lg border border-sand-200 px-5 py-4 transition-colors duration-200 ease-emphasis hover:border-green-200 hover:bg-sand-50" data-id="element-1065" data-mp="36k32t9u1fnlp">
                  <span className="font-display text-[18px] text-ink" data-id="element-1066" data-mp="t91n4oh8v2tt">{policy.title}</span>
                  <ArrowRightIcon aria-hidden className="h-4 w-4 text-green-600 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-1067" data-mp="y2mcxt8ooqhx" />
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-sand-100 py-14 lg:py-20" aria-label="Manifesto publication details" data-id="element-1068" data-mp="aca5skl9ixse">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1069" data-mp="ebshqqv3vyj3">
          <div className="grid gap-8 rounded-media border border-sand-200 bg-white p-8 md:grid-cols-3" data-id="element-1070" data-mp="jcot1phsemyj">
            {[['Published', '2 July 2026'], ['Last updated', '15 August 2026'], ['Languages', 'English, Hausa, Yorùbá, Igbo']].map(([label, value]) => <div key={label} data-id="element-1071" data-mp="1tb7ucj0s6r7p">
                <p className="text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-1072" data-mp="1tciyijy520zc">
                  {label}
                </p>
                <p className="mt-1.5 font-display text-[20px] text-ink" data-id="element-1073" data-mp="22bd06oqbthjr">{value}</p>
              </div>)}
          </div>
        </div>
      </section>

      <CtaBand title="Share the manifesto in your ward." description="Print-ready summaries, WhatsApp graphics and explainer cards are free to download and distribute." primary={{
      label: 'Open campaign resources',
      to: '/resources'
    }} secondary={{
      label: 'Volunteer to distribute',
      to: '/join'
    }} data-id="element-1074" data-mp="1ybvsdonfg8bf" />
    </>;
}